enum SourceQueryParam {
  EXTENSION = 'extension',
  WEB_APP = 'web-app'
}
export default SourceQueryParam;
